module.exports = __webpack_public_path__ + "static/bnr_square-8314d3da9a654661c7ca17a8f555b5cb.png";